export default [
  /** 活动 列表 */
  {
    path: '/newActivity/newActivityList',
    name: 'newActivityList',
    component: () => import(/* webpackChunkName: "newActivityList" */ '../../views/newActivity/newActivityList.vue'),
    meta: {
      title: '',
    },
  },
  /** 活动 详情 */
  {
    path: '/newActivity/newActivityDetail',
    name: 'newActivityDetail',
    component: () =>
      import(/* webpackChunkName: "newActivityDetail" */ '../../views/newActivity/newActivityDetail.vue'),
    meta: {
      title: '',
    },
  },
  /** 我的 活动 */
  {
    path: '/newActivity/myActivity',
    name: 'myActivity',
    component: () => import(/* webpackChunkName: "myActivity" */ '../../views/newActivity/myActivity.vue'),
    meta: {
      title: '',
    },
  },
  /** 已报名用户 */
  {
    path: '/newActivity/signedPeople',
    name: 'signedPeople',
    component: () => import(/* webpackChunkName: "signedPeople" */ '../../views/newActivity/signedPeople.vue'),
    meta: {
      title: '',
    },
  },
]
